<template>
  <div class="policies">
    <b-container>
      <b-row class="policy-row-content">
        <b-col cols="12">
          <h4 class="heading">What information does ftcash collect?</h4>
          <p class="text mb-2">
            If you use or access the ftcash Services, or open a ftcash account,
            we may collect the following personal information:
          </p>
          <ul class="list-text text">
            <li>
              Contact information, such as your name, address, phone, email, and
              other similar information.
            </li>
            <!-- <li>
              Mobile or SMS data, we only collect certain transactional and
              promotional SMS which enable our decision engine to provide
              personalized added services to you.
            </li> -->
            <li>
              Financial information, such as your full bank account, credit /
              debit card number if you choose to use it with the ftcash
              Services.
            </li>
            <li>
              Detailed personal information, such as your date of birth or PAN
              Card no.
            </li>
            <li>
              Other personal information provided by third parties such as
              credit bureaus and identity verification services.
            </li>
            <li>
              Your photo or avatar if you choose to add one to your ftcash
              profile. Other users of the ftcash Services may be able to view
              your photo. You may remove your photo or change it at any time in
              your account settings.
            </li>
            <!-- <li>
              Your contact list information.
            </li> -->
            <!-- <li>
              We collect certain information from your SMSs. Please note that such 
              SMS data is limited to details of the transactions contained in the SMS. 
              We do not collect, read or store any personal SMSs. Also we do not share 
              or transfer SMS/ text message data to any third party.
            </li> -->
            <li>
              Information that you provide to ftcash when interacting with our
              customer support team or other team members via phone, email,
              online form, or other correspondence.
            </li>
            <li>
              You can enable Bluetooth functions after turning on the permission, including discovering and
              configuring PoS. In these functions, we will communicate with PoS via Bluetooth. Please be aware
              that even if you have agreed to enable the Bluetooth permission, we will use Bluetooth for
              communication in this scenario only. You may opt-out using of Bluetooth via "My - Settings - Privacy
              Setting - Disable/Enable Bluetooth permission".
            </li>
            <li>
              Personal information stored with third parties that is provided by
              you to ftcash, such as social media account information and your
              social media contacts. By linking your third party accounts or
              using third party sign-in services, you authorize ftcash to have
              access to this information and you agree that ftcash may collect
              and use this information in accordance with this Privacy Policy.
            </li>
            <li>
              Personal testimonial information or endorsements that you
              voluntarily provide to us and which we may display with your name
              on the ftcash Sites with your consent. To update or delete your
              testimonial, contact us at Support@ftcash.com.
            </li>
          </ul>
          <p class="text text-justify">
            We also collect the following information (Web Browser Information)
            from your device when you use the ftcash Services: your IP address,
            the type of device you use, your device identifier, your operating
            system version, the type of browser you use, your location, and the
            URL that you came from and the next URL that you visit.
            </p>
            <p class="text text-justify">
            When you use our Website or our App, we collect and store your 
            information (personal information) which is provided by you from time 
            to time by explicitly seeking permissions from YOU to get the required 
            information.<br>
            When you use our App, you agree and specifically consent that we may, 
            through automated means, access your messages on your mobile phone and 
            use information from your messages to provide you with enhanced
            services by Ftcash. To the extent possible, we provide you the option of 
            not divulging any specific information that you wish for us not to collect, 
            store or use.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">How does ftcash use the personal information that it collects?</h4>
          <p class="text text-justify mb-2">We use the information to:-</p>
          <ul class="list-text text text-justify">
            <li>Provide the ftcash Services to you.</li>
            <li>Notify you about your account activity.</li>
            <li>Process transactions and collect fees.</li>
            <li>Provide customer support and resolve disputes.</li>
            <li>Verify your identity and account information.</li>
            <li>
              Identify, prevent, and report potentially prohibited, fraudulent,
              or illegal activities.
            </li>
            <li>
              Customize and improve your ftcash experience and the ftcash
              Services.
            </li>
            <li>
              Contact you at your telephone number by voice or SMS to validate
              the telephone number or your ftcash account.
            </li>
            <li>
              We are accessing contact list information so that merchants can 
              easily share invoices to customers who are in their contact list. 
            </li>
            <li>
              We use the contact list to highlight ftcash merchants who are already 
              in your list of contacts. This enables you to pay these known merchants quickly. 
            </li>
            <li>
              We collect and use certain transactional & promotional SMS which enable our 
              decision engine to provide personalized added service to you. Please note 
              that such SMS data is limited to details of the transactions contained in 
              the SMS. We do not collect, read or store any personal SMSs. Also we do not 
              share or transfer SMS/ text message data to any third party.
            </li>
            <p class="text text-justify mb-2">
              (Disclaimer: The above-mentioned access to the contact list and SMS is only for the payment
            service app and will not be used for lending service activities)
            </p>
            <li>
              Notify you about important changes to the ftcash Services and/or
              ftcash's terms and conditions.
            </li>
            <li>
              Provide you with news, offers, and information about the ftcash
              Services based on your communications preferences.
            </li>
            <li>
              Any other purpose that we disclose to you in the course of
              providing the ftcash Services to you.
            </li>
          </ul>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">How does ftcash share my personal information?</h4>
          <p class="text text-justify mb-2">We may share your personal information as follows:</p>
          <ul class="list-text text text-justify">
            <li>
              Provide the ftcash Services to you. When you send or receive money
              using the ftcash Services, we will provide the other ftcash user
              with your registered name, city and state, and your avatar photo
              (if any).
            </li>
            <li>
              If your payment to another ftcash user fails, we may provide that
              user with details of the unsuccessful payment.
            </li>
            <li>
              With third parties to provide, maintain, and improve the ftcash Services, including fraud prevention, identity verification, analytics and marketing services, and financial institutions and other partners that are part of the payment process. It is hereby clarified that we do not share any data of the Ftcash user collected by us in any manner with any third parties (other than RBI regulated financial institution) for lending facilitation services.
            </li>
            <li>
              With third parties upon your request. For example, you may ask
              ftcash to confirm your status as a ftcash user with a third party
              merchant.
            </li>
            <li>
              If we believe disclosure is reasonably necessary to comply with
              any applicable law, legal process, or government request; to
              investigate or bring legal action against someone who may be
              violating our rights, our terms and conditions, or the rights of
              others; or to protect the safety and security of ftcash, our
              users, or the public.
            </li>
            <li>
              With a third party, if we are involved in a merger, acquisition,
              or sale of all or a portion of our stock or assets including but 
              not limited to Credit bureaus financial institutions, body corporates 
              etc. If this occurs, you will be notified of any change to this Privacy 
              Policy, as well as any choices you may have regarding your personal
              information.
            </li>
            <li>
              We may share aggregated, non-personally identifiable information
              with third parties.
            </li>
          </ul>
          <p class="text text-justify">
            Other than as stated in this Privacy Policy, ftcash does not
            disclose or sell any of your personal information to third parties
            without your consent. Please note that third parties, such as
            merchants that you pay and third party websites that you visit, have
            their own privacy policies. ftcash is not responsible for the
            policies and practices of such third parties.
          </p>
          <p class="text text-justify mb-2">
            We do not retain any information collected for any longer than is 
            reasonably considered necessary by us, or such period as may be 
            required by applicable laws. The Company may be required to disclose 
            any information that is lawfully sought from it by a judicial or other 
            competent body pursuant to applicable laws.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">How does ftcash use cookies and web beacons?</h4>
          <p class="text text-justify mb-2">
            Cookies and web beacons are technologies that ftcash and our third
            party service providers use to collect Web Browser Information in
            order to track how the ftcash Sites and ftcash Services are used.
            Cookies are small data files that are stored on your computer's hard
            drive and web beacons are tiny graphics embedded on webpages. These
            technologies allow us to: provide you with a personalized experience
            by recognizing you when you return to the ftcash Sites; better
            understand our users by tracking how they use the ftcash Services;
            improve the design and content of the ftcash Sites by tracking how
            users interact with the ftcash Sites; and to identify and prevent
            fraudulent activity. We may link Web Browser Information to any
            personal information that you submit while on the ftcash Sites. Our
            third party service providers may use cookies and web beacons to
            provide analytics services to ftcash, or to serve you advertisements
            in connection with the ftcash Services.
          </p>
          <p class="text text-justify mb-2">
            The ftcash Sites include social media features that allow you to
            'Like' or share content on third party sites. These features may be
            hosted by the third party sites or the ftcash Sites, and may collect
            your IP address, the ftcash Site page you are visiting, and may set
            a cookie to enable the feature to function. You can change your
            browser settings to refuse cookies, but this may interfere with your
            use of the ftcash Sites. Third parties with whom we partner to
            provide some content such as video clips, use Flash cookies which
            cannot be removed using your browser settings. To learn how to
            manage your Flash cookie preferences, visit the Flash Player
            Settings Manager Help page here
          </p>
          <p class="text text-justify mb-2">
            This Privacy Policy does not apply to third party cookies, web
            beacons, social media features and widgets (such as the Facebook
            Like button), or other tracking technologies used by third parties.
            ftcash is not responsible for the privacy policies and practices of
            such third parties.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">How do I opt-out of receiving promotional emails from ftcash?</h4>
          <p class="text text-justify">
            If you prefer not to receive promotional emails from ftcash, click
            on the unsubscribe link at the bottom of any promotional email from
            ftcash and you will be unsubscribed from receiving any future
            promotional email campaigns. If you have difficulty with the
            unsubscribe process, contact us at Support@ftcash.com.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">What security precautions does ftcash take to protect me?</h4>
          <p class="text text-justify mb-2">
            We have security measures in place to protect your personal
            information, including the use of industry-standard data encryption
            technology and internal policies and restrictions regarding the
            storage of and access to your personal information. Our Platform has 
            stringent security measures in place to protect the loss, misuse
            and alteration of information under control. We endeavour to safeguard 
            and ensure the security of the information provided by you. Please note 
            that no data transmission over the Internet or method of electronic 
            storage can be guaranteed to be 100% secure.
          </p>
          <p class="text text-justify">
            The security and privacy of customers' data (third party) is the responsibility of ftcash Merchants. In light of the same, Merchants must report any incidents of data leakage and be PA DSS Compliant. By consenting to use ftcash Services, the Merchant is also consenting to be prudent on the customer's privacy and security. The Merchant is required to be compliant with the laws at all times.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">How does ftcash handle data security?</h4>
          <p class="text text-justify mb-2">
            At ftcash, our data is securely hosted on the AWS Cloud, where security is primarily handled through
            AWS services. We utilize Amazon CloudWatch for real-time monitoring and alarms, AWS GuardDuty
            for threat and anomaly detection, and implement strict access controls using AWS Security Groups
            and Network ACLs. For sensitive data, we employ AWS Key Management Service (KMS) for
            encryption. These foundational measures ensure effective handling of basic security breaches while
            maintaining robust data protection.
          </p>
          <p class="text text-justify">
            All the data collected from users of ftcash will be stored in servers situated within India.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">Permissions</h4>
          <p class="text text-justify mb-2">Certain permissions are being sought by 
            the service provider/digital platform/APP, from the you at the event of
            downloading the application, registration or requesting for loan.</p>
          <p class="text text-justify mb-2">Disclaimer: the SMS , Contact List access is only for payment service app and it will not be used for
            lending service activities</p>
          <ul class="list-text text text-justify">
            <li>
              Camera Access - to capture the individual image, check the liveliness 
              and authentication of the applicant. The incident may be termed as “Selfie”.
            </li>
            <li>
              Location - This area specific permission helps understand and filter 
              location which are marked as negative/sensitive for lending.
            </li>
            <li>
              Microphone - to complete the process of onboarding.
            </li>
            <li>
              SMS access - To access the promotional and transactional messages which 
              will enable our decision engine to provide personalized added services to 
              you. 
            </li>
            <li>
              Contact List access - to enable merchants to easily share invoices to customers
              who are in their contact list, and to highlight ftcash merchants who are already 
              in your list of contacts,  which enables you to pay these known merchants quickly.
            </li>
            <li>
              Bluetooth access : Bluetooth may need to be enabled in case the customer wishes to make
              payment using our PoS machine.
            </li>
          </ul>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">YOUR CONSENT</h4>
          <p class="text text-justify">
            By using the Website/App and/ or by providing your information, 
            you consent to the collection and use of the information you 
            disclose on the Website in accordance with this Privacy Policy, 
            including but not limited to Your consent for collecting, using, 
            sharing and disclosing your information as per this privacy policy.
          </p>
          <p class="text text-justify">
            If we decide to change our privacy policy, we will post those changes 
            on this page so that you are always aware of what information we collect, 
            how we use it, and under what circumstances we disclose it.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">How do I update my information?</h4>
          <p class="text text-justify">
            If your personal information changes, you can update or correct it
            in your account settings by logging into your account at
            www.ftcash.com. We will retain your information for as long as your
            account is active or as needed to provide you the ftcash Services.
            If you wish to close your account or request that we no longer use
            your information to provide you the ftcash Services, contact us at
            Support@ftcash.com. We will retain and use your information as
            necessary to comply with our legal obligations, resolve disputes,
            and enforce our terms and conditions.
          </p>
          <br>
          <h4 class="heading">Our Data Destruction Protocols?</h4>
          <p class="text text-justify">
            Upon the completion of the retention period for each category of personal data, as described above,
            we will delete or destroy the personal data in our possession or control to the extent technically
            feasible. Alternatively, we may anonymize the personal data, rendering it no longer identifiable as
            personal data.
          </p>
          <br>
          <br>
          <p class="text text-justify">
            In the event you wish to report a breach of the Privacy Policy, you 
            may contact the designated Grievance Officer of the Company at:
          </p>
          <p class="text text-justify">
            Name: Mr. Deepak Kothari
          </p>
          <p class="text text-justify">
            Address: A-405, 4th Floor, Boomerang Building, Yadav Nagar, Chandivali Farm Road, Chandivali. Andheri (East). Mumbai-400072
          </p>
          <p class="text text-justify">
            Contact number: +91 983 349 6939
          </p>
          <p class="text text-justify">
            Email: deepak@ftcash.com
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">What about the privacy of children?</h4>
          <p class="text text-justify">
            ftcash is a general audience website. ftcash does not knowingly
            collect any personal information from anyone under the age of 13.
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">Refer a friend</h4>
          <p class="text text-justify">
            To use ftcash’s referral service, you will have to provide your
            friend’s name and email address which will be used by ftcash to send
            an email inviting them to visit the ftcash Sites. ftcash stores this
            contact information for the sole purpose of sending the email and
            tracking the success of our referral program. Your friend may
            contact us at Support@ftcash.com to request that we remove this
            information from our database. 
          </p>
        </b-col>
        <b-col md="12" sm="12">
          <h4 class="heading">Public Forums</h4>
          <p class="text text-justify">
            The ftcash sites may offer publicly accessible blogs or community
            forums, which may require creation of an account with a third party.
            Any information you provide in these areas may be visible to the
            public, so we recommend that you avoid disclosing personal
            information. To request removal of your personal information from
            these areas, contact us at Support@ftcash.com. In some cases, we may
            not be able to remove your personal information, in which case we
            will let you know if we are unable to do so and why.
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "PrivacyPolicy",
  props: ["paragraphs"],
};
</script>
<style scoped>
.card1 {
  border-radius: 20px;
}
.heading {
  color: var(--mainBlueColor);
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 1.25rem;
}
.text {
  color: var(--mainBlueColor);
  font-size: 1rem;
  font-weight: 500;
  text-align: justify;
}
.list-text {
  list-style-type: outside;
  padding-left: 15px;
}
.policy-row-content {
  justify-content: center;
  text-align: left;
}
/*li::marker {
  color: #e7242a;
}*/

@media (max-width: 767px) {
  /*.policies {
    padding: 0 15px;
  }*/
  .text {
    font-size: 0.75rem;
  }
  .heading {
    text-align: justify;
    font-size: 1.4rem;
  }
}
</style>
